export default __webpack_public_path__ + "4501474639f3278adc1853726ef99c5b.png";